<template>
  <div class="q_pad_lr15px q_mar_t15px">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
      <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          error-text="请求失败，点击重新加载"
      >
        <div class="q_center" style="margin-top: 26vh;" v-if="list.length == 0">
          <img src="@/assets/image/none.png" style="width: 26vw;"/>
          <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
        </div>
        <div class="q_vertical_left q_inter q_mar_b15px q_bor_bottom q_pad_tb5px" v-for="item in list" :key="item.id">
          <van-image v-if="item.type=='1'&&item.isSign!='1'&&item.isSign!='2'" fit="cover"
                     :src="require('@/assets/image/icon_j.png')"/>
          <van-image v-if="item.type=='0'&&item.isSign!='1'&&item.isSign!='2'" fit="cover"
                     :src="require('@/assets/image/icon_j1.png')"/>
          <van-image v-if="item.isSign=='1'" fit="cover" :src="require('@/assets/image/icon_j2.png')"/>
          <van-image v-if="item.isSign=='2'" fit="cover" :src="require('@/assets/image/icon_j3.png')"/>
          <div class="q_inlineblock q_mar_l10px q_inter_cen">
            <p v-if="item.isSign=='1'" class="q_mar_b10px q_text_m q_moit1">每日签到</p>
            <p v-if="item.isSign=='2'" class="q_mar_b10px q_text_m q_moit1">爱心捐款</p>
            <p v-if="item.isSign!='1'&&item.isSign!='2'" class="q_mar_b10px q_text_m q_moit1">{{ item.activityName }}</p>
            <p class="q_mar_b10px q_text_s q_color_gray">{{ item.createTime }}</p>
          </div>
          <div v-if="item.type=='1'" class="q_inlineblock q_text_m q_bold q_inter_ri">-{{ item.score }}积分</div>
          <div v-if="item.type=='0'" class="q_inlineblock q_text_m q_bold q_color_yellow q_inter_ri">
            +{{ item.score }}积分
          </div>
        </div>
      </van-list>

    </van-pull-refresh>
  </div>
</template>

<script>
import {listIntegral} from "@/api/integral";
import {getLoginUser} from "@/api/login";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Integral',
  props: {
    msg: String
  },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      pageParam: {
        pageNum: 0,
        pageSize: 10,
        userId: ''
      },
      user: {}
    }
  },
  created() {
    wxCloseShare()
    getLoginUser().then(res => {
      this.pageParam.userId = res.data.id
      this.user = res.data
    })
  },
  methods: {
    /**
     * 下拉刷新
     */
    onRefresh() {
      this.pageParam = {
        pageNum: 0,
        pageSize: 5,
        userId: this.user.id
      }
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    /**
     * 下滑加载更多
     */
    onLoad() {
      this.pageParam.pageNum++
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      //查询积分信息列表
      listIntegral(this.pageParam).then(res => {
        console.log('resss', res)
        //是否下拉刷新
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        for (let i = 0; i < res.rows.length; i++) {
          this.list.push(res.rows[i]);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= res.total) {
          this.finished = true;
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
  }
}
</script>
<style scoped="scoped">
.q_inter .van-image {
  width: 35px;
  height: 35px;
}

.q_inter_cen {
  width: 220px;
}

.q_inter_cen .q_moit1 {
  width: 220px;
}

.q_inter_ri {
  width: 80px;
  text-align: right;
}
</style>
